// 在浏览器加上标题框（pc端 单页面应用 专用）

class BrowserBack {

  static back() {
    this.setValid();
    window.history.back(-1);
  }

  static isHome(defaultHistoryLength) {
    if (!defaultHistoryLength) {
      defaultHistoryLength = 2;
    }

    if (window.history.length <= defaultHistoryLength) {
      return true;
    }

    const referrer = this.getReferrer();
    return !referrer;
  }

  static save(referrer) {
    if (!referrer) {
      this.clearReferrer();
      return;
    }

    if (this.isValid()) {
      this.setInValid();
      this.clearReferrer();
    } else {
      this.setReferrer(referrer);
    }
  }

  static clearReferrer() {
    this.setReferrer();
  }

  static isValid() {
    return this.getKey() == this.keyValid;
  }

  static setValid() {
    this.setKey(this.keyValid);
  }

  static setInValid() {
    this.setKey(this.keyInValid);
  }

  static setKey(val) {
    sessionStorage.setItem(this.key, val);
  }

  static getKey() {
    return sessionStorage.getItem(this.key);
  }

  static setReferrer(val) {
    if (typeof val == 'undefined') {
      val = '';
    }
    sessionStorage.setItem(this.referrer, val);
  }

  static getReferrer() {
    return sessionStorage.getItem(this.referrer);
  }
}

BrowserBack.key = 'dm-browser-back-mark';
BrowserBack.keyValid = '1';
BrowserBack.keyInValid = '0';
BrowserBack.referrer = 'dm-browser-back-referrer';

export default BrowserBack;
